import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=08589bb2&"
import script from "./FormDetail.vue?vue&type=script&lang=js&"
export * from "./FormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08589bb2')) {
      api.createRecord('08589bb2', component.options)
    } else {
      api.reload('08589bb2', component.options)
    }
    module.hot.accept("./FormDetail.vue?vue&type=template&id=08589bb2&", function () {
      api.rerender('08589bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lgpd/handling/FormDetail.vue"
export default component.exports